module.exports = __webpack_public_path__ + "static/media/card-focus.e36b01a9.svg";